export default {
    path: "/home",
    name: "index",
    component: () => import("@/views/Home.vue"),
};
